import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fillRule="nonzero" fill="none"><path d="M2.275 0C1.575 0 1 .55 1 1.25v13.475c0 .7.575 1.275 1.275 1.275h11.45c.7 0 1.275-.575 1.275-1.275v-9.65L10.275 0h-8Z" fill="#C7C7D2" /><path d="M8.093 6c-.645 0-1.157.185-1.528.565C6.185 6.936 6 7.44 6 8.084h.936c0-.389.08-.698.238-.91.177-.247.468-.37.866-.37.318 0 .565.088.741.264.168.177.257.415.257.724 0 .23-.08.442-.239.645l-.15.168c-.547.486-.883.848-1.007 1.095-.114.23-.167.512-.167.839v.15h.944v-.15c0-.221.045-.415.142-.592.08-.159.203-.309.362-.45l.27-.234c.26-.229.42-.38.48-.455.212-.283.327-.645.327-1.077 0-.53-.177-.954-.521-1.263C9.126 6.15 8.667 6 8.093 6Zm-.15 5.166c.185 0 .344.053.468.176a.586.586 0 0 1 .185.45.619.619 0 0 1-.185.46.701.701 0 0 1-.468.176.593.593 0 0 1-.411-.146l-.04-.04a.589.589 0 0 1-.194-.45c0-.185.062-.335.194-.45a.58.58 0 0 1 .45-.176Z" fill="#FFF" /><path d="M10.275 0v3.65c0 .4.275 1.45 1.525 1.45H15L10.275 0Z" fill="#E8E8EE" /></g></svg>

const Others = React.forwardRef((props, ref) => {
  return (
    <IconBase name="others" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Others.displayName = 'IconOthers'

export default Others
